import { useParams } from 'react-router-dom';
import ProtectedRoute from '@/components/layout/ProtectedRoute';
import Header from '@/components/layout/Header';
import ProjectDetailPage from '@/components/projects/ProjectDetailPage';

const ProjectDetail = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Project ID not found</div>;
  }

  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-background">
        <Header />
        <main className="container py-6">
          <ProjectDetailPage projectId={id} />
        </main>
      </div>
    </ProtectedRoute>
  );
};

export default ProjectDetail;